import { FsListConfig, PaginationStrategy } from '@firestitch/list';

export const ListDefaultConfig: FsListConfig = {
  paging: {
    strategy: PaginationStrategy.Offset,
    limit: 25,
  },
  chips: true,
};
